import React from 'react';

const Spinner = () => (
  <div className="spinner-container">
    <span className="loader"></span>
  </div>
);

export default Spinner;
